// import { Modal } from "@mui/material";
import { Box, Modal, Slider, Typography } from '@mui/material';
import { ArrowBackIcon, Button, ButtonMenu, ButtonMenuItem, CalculateIcon, CardFooter, Checkbox, CloseIcon, Flex, HelpIcon, IconButton, Image, Input, Link, SwapVertIcon, Text } from '@pancakeswap/uikit';
import { type } from '@testing-library/user-event/dist/type';
import Balance from 'components/Balance';
import React, { FC, useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import AnimatedArrow from './AnimatedArrow';
import RoiCalculatorFooter from './RoiCalculatorFooter';
import RoiCard from './RoiCard/RoiCard';
import { getLockUpAddress, getTokenAddress, getWBNBAddress } from "utils/addressHelpers";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import UniRouterABI from "ABI/UniRouterABI.json";
import { getContract } from "utils/contractHelpers";
import { ethers, BigNumber } from "ethers";
import { useWeb3React } from '@web3-react/core';
import FarmRoiCalculatorFooter from './FarmRoiCalculatorFooter';
import FarmRoiCard from './RoiCard/FarmRoiCard';




interface FarmStakeModalProps {
    onClose: () => void;
    open: boolean;
    // onBack?: () => void
    pool?: any;
    stackvalue?: any;
    usdvalue?: any;

}

const ModalHeader = styled(Box)`
    align-items: center;
    background: #00202F;
    display: flex;
    padding: 24px 24px;
    /* border-radius-top-left: 32px; */
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;

`

const ModalHeaderText = styled(Box)`
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    justify-content: space-between;
`

const ScrollableContainer = styled(Box)`
  padding: 24px;
//   max-height: 50vh;
  overflow-y: auto;
  overflow:'scroll'
  ${({ theme }) => theme.mediaQueries.sm} {
    max-height: none;
  }
`

const StyledBalanceInput = styled(Box)`
    background-color: #1A3342;
    border: 1px solid #00FED9;
    border-radius: 16px;
    box-shadow: ${({ theme }) => theme.shadows["inset"]};
    padding: 8px 16px;
`;

const StyledInput = styled(Input) <{ textAlign?: string }>`
  background: transparent;
  border-radius: 0;
  box-shadow: none;
  padding-left: 0;
  padding-right: 0;
  color: white;
  text-align: ${({ textAlign = "right" }) => textAlign};
  border: none;

  ::placeholder {
    color: #B1B3CB;
  }

  &:focus:not(:disabled) {
    box-shadow: none;
  }
`;

const SwitchUnitsButton = styled(IconButton)`
  width: 16px;
`;

const PCheckbox = styled(Checkbox)`
    box-shadow: 0px 0px 0px 1px #00FED9 ;
    background-color : #1A3342;
    &:checked{
        background-color : #00FED9;
    }
    &:hover, &:focus{
        box-shadow: 0px 0px 0px 1px #00FED9 !important;
    }
`

const ButtonComponent = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 20px;
    font-size: 12px;
    background-color: #00FED9;
    box-shadow: none;
    color: rgb(15, 33, 49);
`

const FullWidthButtonMenu = styled(ButtonMenu) <{ disabled?: boolean }>`
  width: 100%;
  height: 30px;
  background-color : #1A3342;
  box-shadow: 0px 0px 0px 1px #00FED9 ;
  border : none !important;

  & > button {
    width: 100%;
  }

  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

const PButtonMenuItem = styled(ButtonMenuItem)`
    color: #000000;
    padding : 0;
`

const FarmRoiCalculatorModal: React.FunctionComponent<FarmStakeModalProps> = ({
    open,
    onClose,
    pool,
    stackvalue,
    usdvalue
}) => {

    // const DURATION = useMemo(() => [t('1D'), t('7D'), t('30D'), t('1Y'), t('5Y')], [t])
    // console.log("pool", pool)
    const { active, library, account } = useWeb3React();
    const [index, setIndex] = useState(0);
    const handleClick = (newIndex) => setIndex(newIndex);
    const [cpmCheck, setcpmCheck] = useState(true);
    const [compounding, setCompounding] = useState(0);
    const handlecompoundingClick = (newIndex) => setCompounding(newIndex);

    const [tokenRoivalue, setTokenRoivalue] = useState(0);
    const [usdRoivalue, setUsdRoivalue] = useState("0");

    const [inputToggle, setInputToggle] = useState(true);
    const [roiUSDInput, setRoiUsdInput] = useState(0);
    const [roitokenInput, setRoiTokenInput] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false)

    const [inputflag, setInputFlag] = useState(false);

    useEffect(() => {
        if (stackvalue) {
            setRoiUsdInput(usdvalue)
            setRoiTokenInput(parseFloat(stackvalue))
        }
    }, [open]);

    const lockupAddress = getLockUpAddress();
    const bnbaddress = getWBNBAddress();
    const tokenAddress = pool.token1Addr; 
    const USDCalculation = async (tokenInput, roiFlag) => {
        const lockUpContract = getContract(DrivenLockupABI, lockupAddress);
        let routeAddress = await lockUpContract.uniRouterAddress();
        const routerContract = getContract(UniRouterABI, routeAddress);
        if (tokenInput >= 0 && tokenInput) { 
            // const routerOut = (pool.RSV) * (tokenInput) * (pool.token0Price); 
            const routerOut = tokenInput / pool.token0Price ; 
            return routerOut
        } else {
            roiFlag && setRoiUsdInput(0);
            return 0;
        }
    }
    // useEffect(() => {
    //     if (!inputToggle) {
    //         USDCalculation(roitokenInput, true);
    //     }
    // }, [roitokenInput]);
    const lock = useRef(true);
    const TokenCalculation = (usdInput, flag) => {
        const lockUpContract = getContract(DrivenLockupABI, lockupAddress); 
        if (usdInput >= 0 && usdInput) {
            // const routerOut = await routerContract.getAmountsOut(ethers.utils.parseEther(usdInput.toString()), ["0x7ef95a0FEE0Dd31b22626fA2e10Ee6A223F8a684", "0x78867BbEeF44f2326bF8DDd1941a4439382EF2A7", tokenAddress]);
            // flag && setRoiTokenInput(parseFloat(ethers.utils.formatEther((routerOut[2]).toString())))
            // return (parseFloat(ethers.utils.formatEther((routerOut[2]).toString())));
            const routerOut = (usdInput) / ((pool.lptokenPrice));  
            return routerOut;
        } else { 
            return 0;
        }
    }
    useEffect(() => {  
        if(lock.current) {
            const amt = TokenCalculation(roiUSDInput, true); 
            setRoiTokenInput(amt)
        }
    }, [roiUSDInput]);

    const setUsdValue = (e) => { 
        lock.current = true;
        setRoiUsdInput(e.target.value);
    }
    const setTokenValue = (e) => {
        lock.current = false;
        const usdValue = e.target.value * pool.lptokenPrice; 
        setRoiUsdInput(usdValue); 
        setRoiTokenInput(e.target.value);
    }

    const simpleROICalculation = (ti, a, d) => {
        // console.log(parseFloat((((parseFloat(ti.toString())) * (parseFloat(a.toString()))) * (d / 365)).toLocaleString('fullwide', {useGrouping:false,
        //     minimumFractionDigits: 9,
        //     maximumFractionDigits: 18,
        //   })));
        return ((parseFloat(ti.toString())) * (parseFloat(a.toString()))) * (d / 365)
    }
    const simplePrincipalCalculation = (ti, a, d) => { 
        console.log(parseFloat(ti.toString()) / ((parseFloat(a.toString())) * (d / 365)));
        return parseFloat(ti.toString()) / ((parseFloat(a.toString())) * (d / 365))
    }
    const compoundPrincipalCalculation = (tokeninput, apy, duration, cmp) => {
        cmp = Math.floor(duration / cmp);
        cmp = cmp ? cmp : 1
        // console.log(cmp);
        let oneapy = (apy) / (cmp);
        // console.log(oneapy.toString());
        let powerCal = oneapy + 1;
        // console.log(powerCal.toString());
        duration = duration / 365;
        // console.log(duration*cmp);
        // powerCal = powerCal.pow(duration * cmp)
        powerCal = Math.pow(parseFloat(powerCal.toString()), -(duration * cmp));
        // console.log(powerCal);
        return (powerCal * tokeninput);
    }
    const compoundROICalculation = (tokeninput, apy, cmp, nCompound) => { 
        // console.log(cmp);
        // let oneapy = (apy) / (cmp);
        // // console.log(oneapy.toString());
        // let powerCal = oneapy + 1;
        // // console.log(powerCal.toString());
        // duration = duration / 365;
        // // console.log(duration*cmp);
        // // powerCal = powerCal.pow(duration * cmp);
        let powerCal = 1+(apy/365)*cmp; 
        powerCal = Math.pow(parseFloat(powerCal.toString()), nCompound);
       
        return tokeninput * powerCal;
    }

    const PrincipalCalculation = async (tokeninput) => {
        let PA;
        let duration;
        let cmp;
        let apy = (pool.apr) / (100);
        switch (index) {
            case 0:
                duration = 1;
                break;
            case 1:
                duration = 7;
                break;
            case 2:
                duration = 30;
                break;
            case 3:
                duration = 365;
                break;
            case 4:
                duration = 1825;
                break;
        }
        switch (compounding) {
            case 0:
                cmp = 1;
                break;
            case 1:
                cmp = 7;
                break;
            case 2:
                cmp = 14;
                break;
            case 3:
                cmp = 30;
                break;

        }
        if (tokeninput) {
            if (cpmCheck) {
                
                // console.log(`${tokeninput},${apy}, ${duration}`);
                PA = simplePrincipalCalculation(tokeninput, apy, duration);
                console.log("PA: ", PA);
                setRoiUsdInput(PA);
                // let usdcalc = await USDCal 
            }
            else {
                PA = compoundPrincipalCalculation(tokeninput, apy, duration, cmp)
                setRoiTokenInput(PA);
                let usdcalc = await USDCalculation((PA), false);
                setRoiUsdInput(usdcalc);
            }
        } else {
            setRoiTokenInput(0)
            setRoiUsdInput(0)
        }
    }
    const ROICalculation = async (usdinput) => {
        let ROI;
        let cmp;
        let duration;
        let apy = (pool.apr) / (100);
        switch (index) {
            case 0:
                duration = 1;
                break;
            case 1:
                duration = 7;
                break;
            case 2:
                duration = 30;
                break;
            case 3:
                duration = 365;
                break;
            case 4:
                duration = 1825;
                break;
        }
        switch (compounding) {
            case 0:
                cmp = 1;
                break;
            case 1:
                cmp = 7;
                break;
            case 2:
                cmp = 14;
                break;
            case 3:
                cmp = 30;
                break; 
        }
        const nCompound = duration / cmp; 
        if (usdinput) {
            if (cpmCheck || nCompound < 1) {
                // ROI = ((parseFloat(usdinput.toString())) * (parseFloat(apy.toString()))) * (duration)
                ROI = simpleROICalculation(usdinput, apy, duration);
                setUsdRoivalue(ROI.toString());
                let usdcalc = await USDCalculation((ROI), false);
                setTokenRoivalue(usdcalc)
            }
            else { 
                console.log(`usdinput: ${usdinput}, apy: ${apy}, cmp: ${cmp}, duration: ${duration}, nCompound: ${nCompound}`);
                ROI = compoundROICalculation(usdinput, apy, cmp, nCompound) 
                setUsdRoivalue(ROI.toString());
                let usdcalc = await USDCalculation((ROI), false);
                setTokenRoivalue(usdcalc)
            }
        } else {
            setTokenRoivalue(0)
            setUsdRoivalue("0")
        }
    }

    useEffect(() => { 
        if (!inputflag) {
            ROICalculation(roiUSDInput);
        }
    }, [roitokenInput, roiUSDInput, index, cpmCheck, compounding]);

    return (
        <>

            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        p: 4,
                        overflow: 'auto',

                    }}>
                    <Box sx={{
                        width: 'auto',
                        background: '#1A3342',
                        borderRadius: '32px',
                        zIndex: '100',
                        minWidth: '330px',
                        maxWidth: '350px',
                        maxHeight: '100vh',
                        overflow: 'hidden',
                    }}>
                        <ModalHeader id="modal-modal-title">
                            <ModalHeaderText>

                                <Box
                                    sx={{
                                        fontSize: '20px',
                                        fontWeight: '600',
                                        lineHeight: '1.1',
                                        display: 'flex',
                                        gap: '10px',
                                        color: '#00FED9',
                                    }}>
                                    {/* <Box sx={{ display: 'flex', alignItems: 'center', }}>
                                        <ArrowBackIcon color="white" width="20px" height="20px" style={{ cursor: 'pointer' }} onClick={onClose} />
                                    </Box> */}

                                    ROI Calculator
                                </Box>
                                <CloseIcon color="#00FED9" width="20px" height="20px" onClick={onClose} style={{ cursor: 'pointer' }} />
                            </ModalHeaderText>

                        </ModalHeader>
                        <ScrollableContainer sx={{ ...(isExpanded && { maxHeight: '50vh' }) }}>
                            <Flex alignItems="center" justifyContent="space-between" mb="8px">
                                <Text color='white' fontWeight={600} lineHeight={1.5} fontSize={'12px'} textTransform={'uppercase'}>{`${pool.token1Symbol}-${pool.token0Symbol} LP`} Staked</Text>
                            </Flex>
                            <StyledBalanceInput>
                                <Flex justifyContent="flex-end">
                                    {inputToggle ?
                                        <Box>
                                            <Flex alignItems="center">
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min="0"
                                                    placeholder={'0.0'}
                                                    onChange={setUsdValue}
                                                    value={roiUSDInput}
                                                />
                                                <Text color='white' marginLeft={'5px'} marginBottom={'2px'} >USD</Text>
                                            </Flex>

                                            <Flex alignItems="center" justifyContent={'end'}>
                                                <Balance
                                                    fontSize="12px"
                                                    color="#B1B3CB"
                                                    textAlign="right"
                                                    decimals={2}
                                                    value={roitokenInput}
                                                    unit=""
                                                    prefix="~"
                                                />
                                                <Box sx={{ color: '#B1B3CB', fontSize: '12px', ml: '5px', whiteSpace: 'nowrap' }} >{`${pool.token1Symbol}-${pool.token0Symbol} LP`}</Box>
                                            </Flex>
                                        </Box>
                                        :
                                        <Box>
                                            <Flex alignItems="center" justifyContent={'end'}>
                                                <StyledInput
                                                    pattern={`^[0-9]*[.,]?[0-9]{0,${'18'}}$`}
                                                    inputMode="decimal"
                                                    min="0"
                                                    placeholder={'0.0'}
                                                    onChange={setTokenValue}
                                                    value={roitokenInput}
                                                />
                                                <Box sx={{ color: 'white', ml: '5px', mb: '2px', whiteSpace: 'nowrap' }} >{`${pool.token1Symbol}-${pool.token0Symbol} LP`}</Box>
                                            </Flex>

                                            <Flex alignItems="center" justifyContent={'end'}>
                                                <Balance
                                                    fontSize="12px"
                                                    color="#B1B3CB"
                                                    textAlign="right"
                                                    decimals={2}
                                                    value={roiUSDInput}
                                                    unit=""
                                                    prefix="~"
                                                />
                                                <Text color="#B1B3CB" marginLeft={'5px'} fontSize={'12px'} >USD</Text>
                                            </Flex>
                                        </Box>}
                                    <Flex alignItems="center" pl="12px">
                                        <SwitchUnitsButton scale="sm" variant="text" >
                                            <SwapVertIcon color="white" onClick={() => setInputToggle(!inputToggle)} />
                                        </SwitchUnitsButton>
                                    </Flex>
                                </Flex>
                            </StyledBalanceInput>
                            <Flex justifyContent="space-between" mt="8px">
                                <ButtonComponent
                                    scale="xs"
                                    mr="4px"
                                    p="4px 16px"
                                    width="68px"
                                    color='rgb(239, 244, 245)'
                                    onClick={() => setRoiUsdInput(100)}
                                >
                                    $100
                                </ButtonComponent>
                                <ButtonComponent
                                    scale="xs"
                                    mr="4px"
                                    p="4px 16px"
                                    width="68px"
                                    onClick={() => setRoiUsdInput(1000)}
                                >
                                    $1000
                                </ButtonComponent>
                                <ButtonComponent
                                    scale="xs"
                                    mr="4px"
                                    p="4px 16px"
                                    width="128px"
                                    disabled={!active}
                                    onClick={async () => { setRoiTokenInput(parseFloat(ethers.utils.formatUnits(pool.user.lpTokenBalance, pool.token0Decimal).toString())); }}
                                >
                                    My Balance
                                </ButtonComponent>
                                <span >
                                    <HelpIcon width="16px" height="16px" color="white" />
                                </span>
                                {/* {tooltipVisible && tooltip} */}
                            </Flex>

                            <Text mt="24px" color="white" bold fontSize="12px" textTransform="uppercase">
                                Staked for
                            </Text>
                            <FullWidthButtonMenu variant="primary" activeIndex={index} onItemClick={handleClick}>
                                <PButtonMenuItem height={'30px'} ><Box sx={{ ...(index !== 0 && { color: 'white' }) }}>1D</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 1 && { color: 'white' }) }}>7D</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 2 && { color: 'white' }) }}>30D</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 3 && { color: 'white' }) }}>1Y</Box></PButtonMenuItem>
                                <PButtonMenuItem height={'30px'}><Box sx={{ ...(index !== 4 && { color: 'white' }) }}>5Y</Box></PButtonMenuItem>
                            </FullWidthButtonMenu>

                            <Text mt="24px" color="white" bold fontSize="12px" textTransform="uppercase">
                                Compounding every
                            </Text>
                            <Flex alignItems="center">
                                <Flex flex="1">
                                    <PCheckbox scale="sm" onClick={() => setcpmCheck(!cpmCheck)} />
                                </Flex>
                                <Flex flex="6">
                                    <FullWidthButtonMenu activeIndex={compounding} onItemClick={handlecompoundingClick} disabled={cpmCheck}>
                                        <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 0 && { color: 'white' }) }}>1D</Box></PButtonMenuItem>
                                        <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 1 && { color: 'white' }) }}>7D</Box></PButtonMenuItem>
                                        <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 2 && { color: 'white' }) }}>14D</Box></PButtonMenuItem>
                                        <PButtonMenuItem height={'30px'} ><Box sx={{ ...(compounding !== 3 && { color: 'white' }) }}>30D</Box></PButtonMenuItem>
                                    </FullWidthButtonMenu>
                                </Flex>
                            </Flex>
                            <AnimatedArrow calculatorState={'state'} />

                            <Flex>
                                <FarmRoiCard pool={pool} PrincipalCalculation={PrincipalCalculation} USDCalculation={USDCalculation} tokenRoivalue={tokenRoivalue} setTokenRoivalue={setTokenRoivalue} usdRoivalue={parseFloat(usdRoivalue)} setUsdRoivalue={setUsdRoivalue} inputflag={inputflag} setInputFlag={setInputFlag} />
                            </Flex>
                        </ScrollableContainer>
                        {/* <CardFooter>Footer</CardFooter> */}
                        {/* const [isExpanded, setIsExpanded] = useState(false) */}
                        <FarmRoiCalculatorFooter
                            pool={pool} isExpanded={isExpanded} setIsExpanded={setIsExpanded}
                        />
                    </Box>
                </Box>
            </Modal>

        </>
    );
};

export default FarmRoiCalculatorModal;
